import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _TagSectionLink_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateGetter(s, r, a) { return a(_assertClassBrand(s, r)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { tracked } from "@glimmer/tracking";
import BaseTagSectionLink from "discourse/lib/sidebar/user/tags-section/base-tag-section-link";
import { bind } from "discourse-common/utils/decorators";
import I18n from "discourse-i18n";
let TagSectionLink = (_class = (_TagSectionLink_brand = /*#__PURE__*/new WeakSet(), class TagSectionLink extends BaseTagSectionLink {
  constructor(_ref) {
    let {
      topicTrackingState
    } = _ref;
    super(...arguments);
    _classPrivateMethodInitSpec(this, _TagSectionLink_brand);
    _initializerDefineProperty(this, "totalUnread", _descriptor, this);
    _initializerDefineProperty(this, "totalNew", _descriptor2, this);
    this.topicTrackingState = topicTrackingState;
    this.refreshCounts();
  }
  refreshCounts() {
    this.totalUnread = this.topicTrackingState.countUnread({
      tagId: this.tagName
    });
    if (this.totalUnread === 0 || _classPrivateGetter(_TagSectionLink_brand, this, _get_newNewViewEnabled)) {
      this.totalNew = this.topicTrackingState.countNew({
        tagId: this.tagName
      });
    }
  }
  get showCount() {
    return this.currentUser?.sidebarShowCountOfNewItems;
  }
  get models() {
    return [this.tagName];
  }
  get route() {
    if (this.currentUser?.sidebarLinkToFilteredList) {
      if (_classPrivateGetter(_TagSectionLink_brand, this, _get_newNewViewEnabled) && _classPrivateGetter(_TagSectionLink_brand, this, _get_unreadAndNewCount) > 0) {
        return "tag.showNew";
      } else if (this.totalUnread > 0) {
        return "tag.showUnread";
      } else if (this.totalNew > 0) {
        return "tag.showNew";
      }
    }
    return "tag.show";
  }
  get currentWhen() {
    return "tag.show tag.showNew tag.showUnread tag.showTop";
  }
  get badgeText() {
    if (!this.showCount) {
      return;
    }
    if (_classPrivateGetter(_TagSectionLink_brand, this, _get_newNewViewEnabled) && _classPrivateGetter(_TagSectionLink_brand, this, _get_unreadAndNewCount) > 0) {
      return _classPrivateGetter(_TagSectionLink_brand, this, _get_unreadAndNewCount).toString();
    } else if (this.totalUnread > 0) {
      return I18n.t("sidebar.unread_count", {
        count: this.totalUnread
      });
    } else if (this.totalNew > 0) {
      return I18n.t("sidebar.new_count", {
        count: this.totalNew
      });
    }
  }
  get suffixCSSClass() {
    return "unread";
  }
  get suffixType() {
    return "icon";
  }
  get suffixValue() {
    if (!this.showCount && (this.totalUnread || this.totalNew)) {
      return "circle";
    }
  }
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "totalUnread", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "totalNew", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, "refreshCounts", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "refreshCounts"), _class.prototype)), _class);
function _get_unreadAndNewCount(_this) {
  return _this.totalUnread + _this.totalNew;
}
function _get_newNewViewEnabled(_this2) {
  return !!_this2.currentUser?.new_new_view_enabled;
}
export { TagSectionLink as default };